import { render } from "./lang-sel.vue?vue&type=template&id=fffe53e2&scoped=true"
import script from "./lang-sel.vue?vue&type=script&lang=js"
export * from "./lang-sel.vue?vue&type=script&lang=js"

import "./lang-sel.vue?vue&type=style&index=0&id=fffe53e2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fffe53e2"]])

export default __exports__